module.exports = __webpack_public_path__ + "img/mosquita_generic_error.a6469ade.png";